import { CreditPolicyCurrency } from './globalTypes'
export const CREDIT_POLICY_CURRENCIES: CreditPolicyCurrency = {
  DK: 'DKK',
  NO: 'NOK',
  SE: 'SEK',
  FI: 'EUR',
}
